
import React, { useEffect } from 'react'
import { IntlProvider } from 'react-intl';
import fetchTranslations from '../../../../common/actions/fetchTranslations';
import { connect } from 'react-redux';
import defaultTranslations from '../../translations';
import getSelectedHotelId from '../../../../common/selectors/getSelectedHotelId';
import getSelectedLocale from '../../../../common/selectors/getSelectedLocale';
import FooterComp from '../../components/Footer';
import get from 'lodash/get';
import withRouterHoc from '../../../../common/components/WithRouteHOC';

const TRANSLATIONS_FEATURE_NAME = 'property_onboarding';

const Footer = (props) => {
  const { customHistory, history, translations } = props;

  useEffect(() => {
    props.fetchTranslations({
      is_feature_metadata: true,
      features: [TRANSLATIONS_FEATURE_NAME],
      defaultTranslations: {
        [TRANSLATIONS_FEATURE_NAME]: defaultTranslations
      }
    });
  }, [translations]);

  if (!props.translations) {
    return null;
  }

  return (<IntlProvider locale={props.language} messages={props.translations}>
    <FooterComp
      customHistory={customHistory}
      history={history}
    />
  </IntlProvider>)
}

const mapStateToProps = state => {
  const translations = get(state.translationsReducer, 'translations.data', {});
  return {
    hotelId: getSelectedHotelId(state),
    language: getSelectedLocale(state),
    translations: translations[TRANSLATIONS_FEATURE_NAME],
  };
}

const mapDispatchToProps = {
  fetchTranslations,
};

export default withRouterHoc(connect(mapStateToProps, mapDispatchToProps)(Footer));
